import MKBox from "components/MKBox";
import Grid from "@mui/material/Grid";
import SortByDropdown from "../components/SortByDropdown";
import SearchBar from "../components/SearchBar";
import PageSelect from "../components/PageSelect";

function UserDatabaseControls() {
  return (
    <MKBox>
      <Grid container spacing={{ xs: 0, lg: 3 }} sx={{ pt: 2, pb: 3, px: 2, mx: "auto" }}>
        <SortByDropdown />
        <SearchBar />
        <PageSelect />
      </Grid>
    </MKBox>
  );
}

export default UserDatabaseControls;
